const InvitesRoutes = [
    {
      name: "AcceptInvite",
      path: "/invites/:projectId/:inviteCode",
      component: () =>
        import(
          /* webpackChunkName: "InvitesModule" */ "./pages/AcceptInvite"
      )
    },
  ];
  
  export default InvitesRoutes;
  